// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__Jyzgt {
  position: absolute;
  bottom: 0;
  left: 0;
}
.styles_wrapper__Jyzgt > svg {
  width: 100px !important;
  height: 200px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Animation/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AACF;AAAE;EACE,uBAAA;EACA,wBAAA;AAEJ","sourcesContent":[".wrapper {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  > svg {\n    width: 100px !important;\n    height: 200px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__Jyzgt`
};
export default ___CSS_LOADER_EXPORT___;
